import type { CandidateAlertWorkFeed } from '@axiom/validation';
import { useApi, TaxonomyUtil } from '@axiom/ui';

import { WorkFeedFilterUtil } from '../../utils/work-feed-filter-util';
import type { FilterPill } from '../../types/work-feed.types';
import { TaxonomyApi } from '../../api/taxonomy-api';

const {
  countryOptions,
  engagementLengthOptions,
  weeklyCommitmentOptions,
  worksiteOptions,
} = WorkFeedFilterUtil;

export const useWorkFeedAlertsPills = (
  workFeedAlert: CandidateAlertWorkFeed
) => {
  const pills: FilterPill[] = [];
  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());

  const practiceAreaOptions = TaxonomyUtil.getPracticeAreaOptions(
    taxonomy.practiceAreas
  );
  const industryOptions = TaxonomyUtil.getIndustryOptions(taxonomy.industries);
  const focusAreaOptions = TaxonomyUtil.getFocusAreaOptions(
    taxonomy.focusAreas
  );
  const legalRoleOptions = TaxonomyUtil.getBusinessTitleOptions(
    taxonomy.businessTitles
  );

  const config = [
    { name: 'practiceAreas', options: practiceAreaOptions },
    { name: 'focusAreas', options: focusAreaOptions },
    { name: 'industries', options: industryOptions },
    { name: 'weeklyCommitments', options: weeklyCommitmentOptions },
    { name: 'countries', options: countryOptions },
    { name: 'worksites', options: worksiteOptions },
    { name: 'engagementLengths', options: engagementLengthOptions },
    { name: 'businessTitles', options: legalRoleOptions },
  ] as const;

  config.forEach(({ name, options }) => {
    const filters = workFeedAlert[name];
    if (filters) {
      filters.forEach(v => {
        const findOpt = options.find(opt => opt.value === v);
        if (findOpt) pills.push({ ...findOpt, name });
      });
    }
  });

  return pills;
};
